export const ONCE = 'ONCE';
export const DAILY = 'DAILY';
export const WEEKLY = 'WEEKLY';
export const MONTHLY = 'MONTHLY';
export const SEMI_ANNUALLY = 'SEMI-ANNUALLY';
export const ANNUALLY = 'ANNUALLY';
export const SELECTIVELY = 'SELECTIVELY';

// Константа отображения теста периода списания по подписке
export const PERIODICITY_TEXT_MAPS = {
  [DAILY]: 'common.daily',
  [WEEKLY]: 'common.weekly',
  [MONTHLY]: 'common.monthly',
  [SEMI_ANNUALLY]: 'common.semi-annually',
  [ANNUALLY]: 'common.annually',
  [SELECTIVELY]: 'can.choose.period',
};
